import { ContactDto } from "../../contact/models"
import { ExternalLinkDto } from "../../integration/ExternalLink"
import PaymentTransaction, { PaymentTransactionDto } from "../../payment/PaymentTransaction"
import { GroupDto } from "../../pricing/Group"
import { PricingRowDto } from "../../pricing/PricingRow"
import { PricingTotalDto } from "../../pricing/PricingTotals"
import { INVOICES } from "../Constants"

type InvoiceDtoAttributes = {
    quoteId: string
    identifier: string
    billingType: string
    externalLinks: ExternalLinkDto[]
    paymentTransactions: PaymentTransactionDto[]
    returnOfInvoiceId: string
    pricingTableId: string
    items: PricingRowDto[]
    groups: GroupDto[]
    totals: PricingTotalDto[]
    totalAmount: string
    balance: string
    contactId: string
    currency: string
    contact: ContactDto
    paidAmount: string
    locationId: string
}

export type InvoiceDto = {
    id: string
    type: typeof INVOICES,
    attributes: InvoiceDtoAttributes
}

export default class Invoice {
    private dto: InvoiceDto
    private paymentTransactions: PaymentTransaction[]

    constructor(dto: InvoiceDto) {
        this.dto = dto
        this.paymentTransactions = this.dto.attributes?.paymentTransactions
            .map(transaction => new PaymentTransaction(transaction)) || []
    }

    isLoaded(): boolean {
        return this.getId() != "" && this.dto.type == "invoices"
    }

    getId(): string {
        return this.dto.id
    }

    getInvoiceDto(): InvoiceDto {
        return this.dto
    }

    getQuoteId(): string {
        return this.dto.attributes.quoteId
    }

    getIdentifier(): string {
        return this.dto.attributes.identifier
    }

    getPaymentTransactions(): PaymentTransaction[] {
        return this.paymentTransactions
    }

    getAllExternalLinks() {
        const externalLinks: ExternalLinkDto[] = []
        const paymentTransactions = this.paymentTransactions
        for (const payment of paymentTransactions) {
            if (payment.isDeleted()) {
                externalLinks.push(...payment.getExternalLinks())
            }
        }
        externalLinks.push(...this.dto.attributes.externalLinks)
        return externalLinks
    }

    getTotalAmount(): string {
        return this.dto.attributes.totalAmount
    }

    getBalance(): string {
        return this.dto.attributes.balance
    }

    getReturnOfInvoiceId(): string {
        return this.dto.attributes.returnOfInvoiceId
    }

    getContactId(): string {
        return this.dto.attributes.contactId
    }

    getCurrency(): string {
        return this.dto.attributes.currency
    }

    getPaidAmount(): string {
        return this.dto.attributes.paidAmount
    }

    getLocationId(): string {
        return this.dto.attributes.locationId
    }
}


// WEBPACK FOOTER //
// ./src/state/invoice/models/invoice.ts